import React, { useState, useEffect } from "react";
import './EmetyaHome.scss';
import { Helmet } from "react-helmet";
import { Link, useNavigate } from "react-router-dom";

export default function EmetyaHome() {
    const [Disclosure, setDisclosure] = useState(false);
    const navigate = useNavigate();

    // Ad-traffic redirect: paid traffic landing on "/" must still reach the GLP-1 comparison page
    const searchParams = new URLSearchParams(window.location.search);
    const isAdTraffic = Boolean(
        searchParams.get('spg') ||
        searchParams.get('ca') ||
        searchParams.get('kd') ||
        searchParams.get('gclid')
    );

    useEffect(() => {
        if (isAdTraffic) {
            navigate('/glp1' + window.location.search, { replace: true });
        }
    }, [isAdTraffic, navigate]);

    if (isAdTraffic) return null;

    const CurrentDate = new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long' });

    const ComingSoonCategories = [
        { Title: "Online Pharmacy", Blurb: "Compare trusted online pharmacies for price, delivery, and service." },
        { Title: "Medicare Advantage", Blurb: "Side-by-side plan comparisons to help you pick the right coverage." },
        { Title: "Home Care", Blurb: "Find and compare top-rated in-home care providers near you." },
        { Title: "Medical Alert Systems", Blurb: "Reviews of the best medical alert devices for safety and peace of mind." },
    ];

    return (
        <div className="EmetyaHome">
            {/* Helmet */}
            <Helmet>
                {/* TITLE */}
                <title>Emetya – Compare the Best Products & Services of 2026</title>

                {/* META TAGS */}
                <meta property="og:locale" content="en_US" />
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://www.emetya.com/" />
                <meta name="description" content="Emetya delivers independent, research-driven comparisons of the best GLP-1 weight loss programs and assisted living communities of 2026. Updated monthly and free to use." />
                <meta property="og:title" content="Emetya – Compare the Best Products & Services of 2026" />
                <meta property="og:description" content="Independent comparisons of top GLP-1 weight loss providers and assisted living communities. Research-driven rankings, updated monthly." />
                <meta property="og:site_name" content="Emetya" />
                <meta name="keywords" content="Emetya, compare, best GLP-1 weight loss, assisted living, memory care, top 10 comparisons, senior living, weight loss programs" />
            </Helmet>
            {/* CategoryNav */}
            <div className="CategoryDisclosure">
                <div className="CategoryNavShape">
                    <h1 onMouseOut={() => setDisclosure(false)}>We may earn a commission from featured offers, which can affect how and where they appear. <span onClick={() => setDisclosure(!Disclosure)}>Advertiser Disclosure.</span></h1>
                    {Disclosure ?
                        <div className="CategoryNavShapeDiscluser">
                            <h2>The content on this page was created independently from the Emetya editorial team. We may receive a commission from featured partners, which can influence how offers are presented — including their placement, rating, and order. In addition to compensation, we may also evaluate a brand’s reputation, popularity, and service quality when determining scores. While we strive to keep all information accurate and current, Emetya does not include every brand or offer available in the marketplace, and we cannot guarantee the completeness or accuracy of the content at the time of viewing.</h2>
                        </div>
                        : null}
                </div>
            </div>
            {/* EmetyaHomeHeader */}
            <div className="EmetyaHomeHeader">
                <div className="EmetyaHomeHeaderLogo">
                    <img src={require(`../../Images/Logo.png`)} alt="Emetya" />
                    <h1>Emetya<span>Health</span></h1>
                </div>
                <div className="EmetyaHomeHeaderNav">
                    <Link to="/glp1">Weight Loss</Link>
                    <Link to="/alf">Senior Living</Link>
                </div>
            </div>
            {/* EmetyaHomeHero */}
            <div className="EmetyaHomeHero">
                <h1>Compare the Best. Choose with Confidence.</h1>
                <h2>Independent, research-driven comparisons of top providers — updated {CurrentDate}.</h2>
                <div className="EmetyaHomeHeroButtons">
                    <Link className="EmetyaHomeHeroButtonMain" to="/glp1">Best GLP-1 Weight Loss</Link>
                    <Link className="EmetyaHomeHeroButtonSecond" to="/alf">Best Assisted Living</Link>
                </div>
            </div>
            {/* EmetyaHomeCategories */}
            <div className="EmetyaHomeCategories">
                <h1>Browse Categories</h1>
                <h2>Every ranking is built on research, real user feedback, and editorial review.</h2>
                <div className="EmetyaHomeCategoriesGrid">
                    <Link className="EmetyaHomeCategoryTile" to="/glp1">
                        <img src={require(`../../EmetyaImages/glp-1-blog-post.jpg`)} alt="GLP-1 Weight Loss" />
                        <div className="EmetyaHomeCategoryTileText">
                            <h3>GLP-1 Weight Loss</h3>
                            <p>Compare the top telehealth providers for Ozempic®, Wegovy®, Zepbound® and compounded GLP-1 programs.</p>
                            <span>View Top 10 →</span>
                        </div>
                    </Link>
                    <Link className="EmetyaHomeCategoryTile" to="/alf">
                        <img src={require(`../../AlfImages/ahava-g-atrium-lounge.jpg`)} alt="Assisted Living & Memory Care" />
                        <div className="EmetyaHomeCategoryTileText">
                            <h3>Assisted Living & Memory Care</h3>
                            <p>Explore top-rated senior living communities with trusted care, amenities, and transparent pricing.</p>
                            <span>View Top Communities →</span>
                        </div>
                    </Link>
                    {ComingSoonCategories.map((C, index) => {
                        return (
                            <div className="EmetyaHomeCategoryTile EmetyaHomeCategoryTileSoon" key={C.Title + index}>
                                <div className="EmetyaHomeCategoryTileText">
                                    <span className="EmetyaHomeCategoryTileChip">Coming Soon</span>
                                    <h3>{C.Title}</h3>
                                    <p>{C.Blurb}</p>
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>
            {/* EmetyaHomeTrending */}
            <div className="EmetyaHomeTrending">
                <h1>Trending This Month</h1>
                <div className="EmetyaHomeTrendingCards">
                    <div className="EmetyaHomeTrendingCard">
                        <img src={require(`../../EmetyaImages/weight-loss-injections-long-island.jpg`)} alt="Top GLP-1 Weight Loss Programs" />
                        <div className="EmetyaHomeTrendingCardText">
                            <h3>Top GLP-1 Weight Loss Programs of {CurrentDate}</h3>
                            <p>We compared pricing, medication options, and medical support across the leading telehealth weight loss providers. See which programs ranked highest this month.</p>
                            <Link to="/glp1">Compare Weight Loss Providers →</Link>
                        </div>
                    </div>
                    <div className="EmetyaHomeTrendingCard">
                        <img src={require(`../../AlfImages/ahava-hero.jpg`)} alt="Best Assisted Living Communities" />
                        <div className="EmetyaHomeTrendingCardText">
                            <h3>Best Assisted Living & Memory Care Communities</h3>
                            <p>From daily care and dining to activities and award-winning memory care, see the senior living communities families trust most this month.</p>
                            <Link to="/alf">Compare Senior Living →</Link>
                        </div>
                    </div>
                </div>
            </div>
            {/* EmetyaHomeRanks */}
            <div className="EmetyaHomeRanks">
                <h1>How Emetya Ranks</h1>
                <div className="EmetyaHomeRanksSteps">
                    <div className="EmetyaHomeRanksStep">
                        <img src={require(`../../Images/check-mark.png`)} alt="Research & Data" />
                        <h3>Research & Data</h3>
                        <p>We analyze pricing, features, availability, and published data for every provider before it ever appears in a ranking.</p>
                    </div>
                    <div className="EmetyaHomeRanksStep">
                        <img src={require(`../../Images/star.png`)} alt="Real User Feedback" />
                        <h3>Real User Feedback</h3>
                        <p>Verified reviews and user experiences shape our scores, so rankings reflect how services perform in the real world.</p>
                    </div>
                    <div className="EmetyaHomeRanksStep">
                        <img src={require(`../../Images/verifed.png`)} alt="Editorial Review" />
                        <h3>Editorial Review</h3>
                        <p>Our editorial team reviews every comparison for accuracy and updates rankings monthly as offers and services change.</p>
                    </div>
                </div>
            </div>
            {/* EmetyaHomeTrust */}
            <div className="EmetyaHomeTrust">
                <h2>500K+ comparisons served</h2>
                <h2>Updated monthly</h2>
                <h2>Free to use</h2>
            </div>
            {/* CompaniesFooter */}
            <div className="CompaniesFooter">
                <h6>Information provided on Emetya is for educational purposes only and is not intended as medical advice. Your health and wellness needs are personal, and the products or services featured may not be suitable for your individual situation. Emetya does not provide medical diagnoses, treatment plans, or personalized health recommendations. Always consult a licensed healthcare provider for advice tailored to your specific medical needs.</h6>
                <div className="Footerlogo">
                    <img src={require(`../../Images/Logo.png`)} alt="" />
                    <h1>Emetya<span>Health</span></h1>
                </div>
                <h5>©2026 Emetya Health. All rights reserved.</h5>
                <span>
                    <a href="https://www.emetya.com/privacy-policy">Privacy Policy</a>
                    <a href="https://www.emetya.com/terms-of-use">Terms of Use</a>
                </span>
            </div>
        </div>
    )
}
